"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.containsAll = exports.containsAny = void 0;
exports.containsAny = function (haystack, needle) {
    return needle.some(function (v) {
        if (haystack instanceof Array) {
            return haystack.indexOf(v) >= 0;
        }
        return false;
    });
};
exports.containsAll = function (haystack, needle) {
    return needle.every(function (v) {
        if (haystack instanceof Array) {
            return haystack.indexOf(v) >= 0;
        }
        return false;
    });
};
exports.default = {
    containsAny: exports.containsAny,
    containsAll: exports.containsAll
};
